import './XpektorTooltip.scss';
import { Tooltip } from 'react-tooltip';

/* eslint-disable react/prop-types */
export default function XpektorTooltip({ hoverId, content, isOpen, maxWidth }) {
  return (
    <div className="xpektor-tooltip-wrapper">
      <Tooltip
        className="xpektor-tooltip"
        id={hoverId}
        place="top"
        opacity={1}
        isOpen={isOpen}
        style={maxWidth && { maxWidth: `${maxWidth}px` }}
      >
        {content}
      </Tooltip>
    </div>
  );
}
